import { TransactionItem } from '@/types/transactions';
import { SVTable } from '../core';
import { SVTableHeader, SVTableRow } from '@/types/common';
import { ROUTES } from '@/constants/routes';
import TransactionAmount from './TransactionAmount';

const headers: SVTableHeader[] = [
  {
    content: 'Date',
    key: 'date',
  },
  {
    content: 'Amount',
    key: 'amount',
  },
  {
    content: 'Description',
    key: 'desc',
  },
  {
    content: 'Available Balance',
    key: 'balance',
  },
  {
    content: 'Status',
    key: 'status',
  },
  {
    content: '',
    key: 'details',
  },
];

type TransactionTableProps = {
  transactionList: TransactionItem[];
  bankAccountId: string;
  emptyTableContent?: string;
} & (
  | {
      hasPagination: true;
      totalRecordCount: number;
      page: number;
      setPage: React.Dispatch<React.SetStateAction<number>>;
    }
  | {
      hasPagination?: false;
      totalRecordCount?: never;
      page?: never;
      setPage?: never;
    }
);

export default function TransactionTable({
  transactionList,
  bankAccountId,
  emptyTableContent = '',
  hasPagination = false,
  totalRecordCount,
  page,
  setPage,
}: TransactionTableProps) {
  const rows: SVTableRow[] = transactionList.map(transaction => {
    const { id, startedAt, description, balance, statusLabel } = transaction;

    return {
      key: `row${id}`,
      cells: [
        {
          key: `date${id}`,
          type: 'date',
          content: startedAt,
        },
        {
          key: `amount${id}`,
          type: 'custom',
          content: <TransactionAmount transaction={transaction} />,
        },
        {
          key: `desc${id}`,
          type: 'text',
          content: description,
        },
        {
          key: `balance${id}`,
          type: 'amount',
          content: balance?.value || '',
        },
        {
          key: `status${id}`,
          type: 'text',
          content: statusLabel,
        },
        {
          key: `details${id}`,
          type: 'link',
          content: `${ROUTES.BANK_ACCOUNTS}/${bankAccountId}${ROUTES.TRANSACTIONS}/${id}`,
        },
      ],
    };
  });

  if (hasPagination && setPage) {
    return (
      <SVTable
        ariaLabel="Recent Transactions"
        headers={headers}
        rows={rows}
        emptyTableContent={emptyTableContent}
        hasPagination={hasPagination}
        page={page}
        setPage={setPage}
        totalRecordCount={totalRecordCount}
      />
    );
  }

  return (
    <SVTable
      ariaLabel="Recent Transactions"
      headers={headers}
      rows={rows}
      emptyTableContent={emptyTableContent}
    />
  );
}
